import useMutationApi from 'src/api/useMutationApi';

const useLogOut = () => {
  return useMutationApi<void, void>({
    endpoint: 'auth/logout',
    method: 'POST',
  });
};

export default useLogOut;
